import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Form, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/styles.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/login`, { username, passwordHash: password })
      .then(res => {
        localStorage.setItem('token', res.data.token);
        navigate('/bandleader');
      })
      .catch(() => alert('Login failed'));
  };

  return (
    <Container fluid className="mt-5">
      <Card className="mx-auto card-custom animate__animated animate__fadeIn" style={{ maxWidth: '400px' }}>
        <Card.Header className="text-center py-4" style={{ background: 'linear-gradient(to right, #ff6b6b, #4ecdc4)', color: 'white' }}>
          <div className="mb-3">
            <img 
              src="/logo.png" 
              alt="Karaoke Band Logo" 
              style={{ maxWidth: '150px', maxHeight: '100px', objectFit: 'contain' }} 
            />
          </div>
          <h2 className="mb-0" style={{ fontFamily: "'Poppins', sans-serif", letterSpacing: '1px' }}>
            Band Leader Login
          </h2>
        </Card.Header>
        <Card.Body className="p-4">
          <Form onSubmit={handleLogin}>
            <Form.Group className="mb-3 animate__animated animate__fadeIn" controlId="formUsername">
              <Form.Label style={{ fontFamily: "'Montserrat', sans-serif" }}>Username</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter username"
                value={username}
                onChange={e => setUsername(e.target.value)}
                required
                className="shadow-sm"
              />
            </Form.Group>

            <Form.Group className="mb-3 animate__animated animate__fadeIn" style={{ animationDelay: '0.2s' }} controlId="formPassword">
              <Form.Label style={{ fontFamily: "'Montserrat', sans-serif" }}>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                className="shadow-sm"
              />
            </Form.Group>

            <Button className="btn-custom-primary w-100 animate__animated animate__fadeIn" type="submit" style={{ animationDelay: '0.4s' }}>
              Login
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Login;